import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className={"root"}>
      <div id={"loader"}></div>
    </div>
  );
};

export default Loading;
